import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import { connect } from 'react-redux';
import get from 'lodash.get';

// components
import { PdpRespPreviewMessageBanner } from '../PdpRespPreviewMessageBanner/PdpRespPreviewMessageBanner';
import { PdpRespPrintHeader } from '../PdpRespPrintHeader/PdpRespPrintHeader';
import { PdpRespSimilarItemsLanding } from '../PdpRespSimilarItems/PdpRespSimilarItemsLanding';
import { PdpRespBreadcrumbs } from '../PdpRespBreadcrumbs/PdpRespBreadcrumbs';
import { PdpRespHeroCarousel } from '../PdpRespHeroCarousel/PdpRespHeroCarousel';
import { PdpRespHeroCarouselPrint } from '../PdpRespHeroCarousel/PdpRespHeroCarouselPrint';
import { PdpRespIconBubblesWrapper } from '../PdpRespIconBubbles/PdpRespIconBubblesWrapper';
import { PdpRespTitle } from '../PdpRespTitle/PdpRespTitle';
import { PdpSharedSidebarFavorites } from '../PdpSharedSidebarFavorites/PdpSharedSidebarFavorites';
import { PriceDisplay } from 'dibs-buyer-price';
import { PdpRespSidebarButtons } from '../PdpRespSidebarButtons/PdpRespSidebarButtons';
import { PdpRespSidebarBlurbs } from '../PdpRespSidebarBlurbs/PdpRespSidebarBlurbs';
import { PdpSharedDescriptionAbout } from '../PdpSharedDescriptions/PdpSharedDescriptionAbout';
import { PdpSharedDescriptionAdditionalOptions } from '../PdpSharedDescriptions/PdpSharedDescriptionAdditionalOptions';
import { PdpRespDetails } from '../PdpRespDetails/PdpRespDetails';
import { PdpRespShippingReturns } from '../PdpRespDetails/PdpRespShippingReturns';
import { PdpSharedDescriptionAboutCreator } from '../PdpSharedDescriptions/PdpSharedDescriptionAboutCreator';
import { PdpSharedDescriptionAboutMaker } from '../PdpSharedDescriptions/PdpSharedDescriptionAboutMaker';
import { PdpRespBuyerAssuranceBox } from '../PdpRespBuyerAssuranceBox/PdpRespBuyerAssuranceBox';
import { PdpRespSidebarSellerInfo } from '../PdpRespSidebarSellerInfo/PdpRespSidebarSellerInfo';
import { PdpRespSidebarContact } from '../PdpRespSidebarContact/PdpRespSidebarContact';
import { PdpRespSimilarItemsGridSeller } from '../PdpRespSimilarItems/PdpRespSimilarItemsGridSeller';
import { PdpRespSimilarItemsFooter } from '../PdpRespSimilarItems/PdpRespSimilarItemsFooter';
import { PdpRespSeoLinks } from '../PdpRespSeoLinks/PdpRespSeoLinks';
import { PdpRespDealerDetails } from '../PdpRespDealerDetails/PdpRespDealerDetails';
import { PdpSharedQuantitySelect } from '../PdpSharedButtons/PdpSharedQuantitySelect';
import { PdpSharedReminderLoader } from '../PdpSharedReminder/PdpSharedReminderLoader';
import { PdpSharedRecentHistoryTracker } from '../PdpSharedRecentHistoryTracker/PdpSharedRecentHistoryTracker';
import { PdpSharedPromoCode } from '../PdpSharedPromoCode/PdpSharedPromoCode';
import { SharedRecentlyViewedItems } from '../../shared/SharedRecentlyViewedItems/SharedRecentlyViewedItems';
import { PdpSharedRestrictedMaterialsLoader } from '../PdpSharedRestrictedMaterials/PdpSharedRestrictedMaterialsLoader';
import { PdpSharedBuyerProtectionBox } from '../PdpSharedBuyerProtectionBox/PdpSharedBuyerProtectionBox';
import { PdpRespQrCode } from '../PdpRespQrCode/PdpRespQrCode';
import { PdpRespSwatchSelector } from '../PdpRespSwatchSelector/PdpRespSwatchSelector';
import { PdpSharedLeadTime } from '../PdpSharedLeadTime/PdpSharedLeadTime';
import { PdpRespExitModalLazy } from '../PdpRespExitModal/PdpRespExitModalLazy';
import { TradeLoggedOutUserLoader } from '../../components/global/TradeLoggedOutUser/TradeLoggedOutUserLoader';
import { PdpSharedShippingBadgeLazy } from '../PdpSharedShippingDetails/PdpSharedShippingBadgeLazy';
import { PdpSharedShippingDetailsLazy } from '../PdpSharedShippingDetails/PdpSharedShippingDetailsLazy';
import { PdpSharedTradePointsEarnedMessage } from '../PdpSharedTradePointsEarnedMessage/PdpSharedTradePointsEarnedMessage';
import { PdpRespConsumerSourcingModalLoader } from '../PdpRespConsumerSourcingModal/PdpRespConsumerSourcingModalLoader';

// callouts
import { NOTIFICATION_KEYS as SHARED_NOTIFICATION_KEYS } from '../PdpSharedNotifications/pdpSharedNotificationConstants';
import { SharedNotificationsWrapper } from '../../shared/SharedNotificationsWrapper';
import { PdpSharedNotificationMultiplePdpVisitsModalLoader } from '../PdpSharedNotifications/PdpSharedNotificationMultiplePdpVisitsModal/PdpSharedNotificationMultiplePdpVisitsModalLoader';
import { PdpSharedSourcingModalLoaderWrapper } from '../PdpSharedModals/PdpSharedSourcingModal/PdpSharedSourcingModalLoaderWrapper';
import { getSelectedSku } from '../helpers/getSelectedSku';

// helpers
import classnames from 'classnames';
import { useContactDealerAutoModal } from 'dibs-buyer-layout/exports/contactDealerLauncher';
import { trackPdpViewMoreCtaClick } from 'dibs-recent-history/src/recentHistoryTracking';
import {
    showPdpFreeShippingOnlyTestVariant,
    showPdpFreeShippingFullTestVariant,
    trackPdpFreeShippingTestForDesktop,
} from '../helpers/pdpTestVariantsHelpers';

// styles
import styles from './PdpRespContainer.scss';
import { SuspectedTradeUserLoader } from '../../components/global/SuspectedTradeUser/SuspectedTradeUserLoader';

/* eslint-disable react/display-name, react/prop-types */
// disable for function as child of PdpRespNotificationsWrapper

export function PdpRespContainerComponent(props) {
    const {
        printWithPrice,
        currency,
        viewer,
        user,
        isPdpRespPreviewPage,
        item,
        displayInfo,
        sellerItems,
        similarGridItems,
        similarLandingItems,
        vipUserRelationship,
        shipmentQuote,
        shipment,
        relayVariables,
        relay,
        transactions,
        selectedSkuId,
        onSkuChange,
    } = props;
    const {
        isMultiSku,
        itemId,
        userId,
        isClient,
        isTrade,
        fetchUser,
        showSimilarItems,
        relationshipUserIds,
        isVip,
    } = relayVariables;
    const selectedSku = getSelectedSku(item, selectedSkuId);
    const isNewAndCustom = get(item, 'itemType') === 'NEW_MADE_TO_ORDER';
    const selectedSkuLeadTime = get(selectedSku, 'skuLeadTime');
    // ab tests on free shipping
    const isPdpFreeShippingOnlyTestVariant = isClient && showPdpFreeShippingOnlyTestVariant();
    const isPdpFreeShippingFullTestVariant = isClient && showPdpFreeShippingFullTestVariant();
    const isFreeShippingTestVariant =
        isPdpFreeShippingOnlyTestVariant || isPdpFreeShippingFullTestVariant;
    // trade only gets points for items that are not jewelry and fashion
    const [hasFiredFreeShippingAbcTestTracking, setHasFiredFreeShippingAbcTestTracking] = useState(
        false
    );

    useContactDealerAutoModal({
        itemId,
        userId,
        environment: relay.environment,
        currency,
    });

    useEffect(() => {
        if (!hasFiredFreeShippingAbcTestTracking) {
            setHasFiredFreeShippingAbcTestTracking(true);
            trackPdpFreeShippingTestForDesktop();
        }
    }, [hasFiredFreeShippingAbcTestTracking, setHasFiredFreeShippingAbcTestTracking]);

    return (
        <div>
            {/* Preview Page Message Banner */}
            {isPdpRespPreviewPage && <PdpRespPreviewMessageBanner />}

            {/* Print Header */}
            {isClient && <PdpRespPrintHeader itemId={itemId} className={styles.printShow} />}

            {/* Similar Items */}
            <div className={styles.printHide}>
                <PdpRespSimilarItemsLanding
                    relayVariables={{
                        isClient,
                        showSimilarItems,
                    }}
                    item={item}
                    similarItems={similarLandingItems}
                    viewer={viewer}
                    user={user}
                    vipUserRelationship={vipUserRelationship}
                />
            </div>

            {/* Notification reminder loader */}
            <PdpSharedReminderLoader
                relayVariables={{
                    userId,
                    fetchUser,
                    itemId,
                    isClient,
                }}
                environment={relay.environment}
                load={!!user}
            />

            {/* Consumer Sourcing Modal*/}
            {!viewer.disableConsumerSourcingModal && !!userId && !isTrade && !isVip && (
                <PdpRespConsumerSourcingModalLoader
                    item={item}
                    userId={userId}
                    environment={relay.environment}
                />
            )}

            {/* PdpBreadcrumbs */}
            <div className={styles.printHide}>
                <PdpRespBreadcrumbs item={item} />
            </div>

            <div className="rowFlex">
                <div className={classnames(styles.topContainer, 'colXs12 colLg7 colXl8')}>
                    {/* Image Carousel */}
                    <div className={styles.printHide}>
                        <PdpRespHeroCarousel
                            itemTitle={item.title || ''}
                            itemImage={item.firstPhotoWebPath || ''}
                            item={item}
                            selectedSkuId={selectedSkuId}
                            user={user}
                            environment={relay.environment}
                            relayVariables={{
                                userId,
                                fetchUser,
                                itemId,
                                isClient,
                            }}
                            viewer={viewer || null}
                            disableZoomModal={isPdpRespPreviewPage}
                            disableRequestMoreImagesModal={isPdpRespPreviewPage}
                        />
                    </div>
                    {/* Stripped Image Carousel (print view) */}
                    {isClient && (
                        <div className={styles.printShow}>
                            <PdpRespHeroCarouselPrint item={item} selectedSkuId={selectedSkuId} />
                        </div>
                    )}

                    {/* Social Icons / Print */}
                    <div className={styles.printHide}>
                        <PdpRespIconBubblesWrapper
                            relayVariables={{
                                itemId,
                                isTrade,
                                isClient,
                            }}
                            skuId={selectedSkuId}
                            item={item}
                            user={user}
                            viewer={viewer}
                        />
                    </div>
                </div>

                {/* Sidebar */}
                <div className={`${styles.topContainer} colXs12 colLg5 colXl4`}>
                    <div className={styles.sidebarContainer}>
                        <div className="rowFlex">
                            {/* Title */}
                            <div className="colXs12 colLg10">
                                <PdpRespTitle item={item} />
                            </div>
                            {/* Favorite / Folder */}
                            {viewer.isFavoritesEnabled && (
                                <div className={`${styles.printHide} colXs2`}>
                                    <PdpSharedSidebarFavorites
                                        environment={relay.environment}
                                        heartIconWrapperClass={styles.heartIconWrapper}
                                        itemTitle={item.title || ''}
                                        itemImage={item.firstPhotoWebPath || ''}
                                        itemId={itemId}
                                        isClient={isClient}
                                        userId={userId}
                                        wrapperClass={styles.favoritesWrapper}
                                    />
                                </div>
                            )}
                        </div>

                        {/* Full Test Variant for Trade, move Free Shipping Pill here so Points earn message can be next to price*/}
                        {isClient && isTrade && (
                            <div className={styles.shippingBadgeContainer}>
                                <PdpSharedShippingBadgeLazy item={item} viewer={viewer} />
                            </div>
                        )}
                        <div
                            className={classnames({
                                [styles.printHide]: !printWithPrice,
                            })}
                        >
                            <div className={styles.priceWithAccessoryInlineContainer}>
                                <PriceDisplay
                                    currency={currency}
                                    displayInfo={displayInfo}
                                    item={item}
                                    page={'pdp'}
                                    sku={isMultiSku ? selectedSku : null}
                                    transactions={isMultiSku ? transactions : null}
                                />
                                {isClient && (
                                    <PdpSharedTradePointsEarnedMessage
                                        item={item}
                                        priceInfoDisplay={displayInfo?.pricing || null}
                                    />
                                )}
                            </div>
                            <div className={styles.printHide}>
                                <PdpSharedPromoCode
                                    displayInfo={displayInfo}
                                    itemId={itemId}
                                    user={user}
                                    userId={userId}
                                    isPdpFreeShippingFullTestVariant={
                                        isPdpFreeShippingFullTestVariant
                                    }
                                />
                            </div>
                        </div>
                        {isMultiSku && (
                            <PdpRespSwatchSelector
                                item={item}
                                user={user}
                                selectedSkuId={selectedSkuId}
                                onClick={skuId => {
                                    onSkuChange(skuId);
                                }}
                                showSwatchDescriptionOnHover
                            />
                        )}
                        <TradeLoggedOutUserLoader />
                        {isClient && (
                            <SuspectedTradeUserLoader
                                user={user}
                                item={item}
                                viewer={viewer}
                                itemSearch={null}
                            />
                        )}
                        {isFreeShippingTestVariant && (
                            <div className={styles.shippingDetailContainer}>
                                <PdpSharedShippingDetailsLazy
                                    item={item}
                                    viewer={viewer}
                                    user={user}
                                    shipmentQuote={shipmentQuote}
                                    currency={currency}
                                    userId={userId}
                                    itemId={itemId}
                                    relay={relay}
                                />
                            </div>
                        )}
                        {isNewAndCustom && selectedSkuLeadTime && (
                            <div
                                className={classnames({
                                    [styles.leadTimeContainer]: !isFreeShippingTestVariant,
                                })}
                            >
                                <PdpSharedLeadTime
                                    leadTime={selectedSkuLeadTime}
                                    isFreeShippingTestVariant={isFreeShippingTestVariant}
                                />
                            </div>
                        )}
                        {/* Item Ctas */}
                        {isClient && (
                            <div className={`${styles.printHide} ${styles.itemCtasWrapper}`}>
                                <PdpSharedQuantitySelect
                                    item={item}
                                    viewer={viewer}
                                    selectedSkuId={selectedSkuId}
                                >
                                    {function quantitySelection(quantitySelected) {
                                        return (
                                            <PdpRespSidebarButtons
                                                currency={currency}
                                                relayVariables={{
                                                    userId,
                                                    isMultiSku,
                                                    itemId,
                                                    relationshipUserIds,
                                                }}
                                                isClient={isClient}
                                                user={user}
                                                item={item}
                                                displayInfo={displayInfo}
                                                quantitySelected={quantitySelected}
                                                skuId={selectedSkuId}
                                            />
                                        );
                                    }}
                                </PdpSharedQuantitySelect>
                            </div>
                        )}

                        {/* Restricted Materials */}
                        {isClient && (
                            <PdpSharedRestrictedMaterialsLoader
                                environment={relay.environment}
                                itemId={itemId}
                                isClient={isClient}
                            />
                        )}

                        {/* Blurbs */}
                        {!isPdpFreeShippingFullTestVariant && (
                            <PdpRespSidebarBlurbs
                                currency={currency}
                                relayVariables={{
                                    userId,
                                    itemId,
                                    isTrade,
                                    isVip,
                                    isClient,
                                }}
                                viewer={viewer}
                                item={item}
                                user={user}
                                displayInfo={displayInfo}
                                vipUserRelationship={vipUserRelationship}
                                shipmentQuote={shipmentQuote}
                                shipment={shipment}
                                showLeadTimeBlurb={!isNewAndCustom && !isMultiSku}
                                isPdpFreeShippingOnlyTestVariant={isPdpFreeShippingOnlyTestVariant}
                            />
                        )}

                        {isClient && (
                            <div className={styles.printHide}>
                                <div
                                    className={classnames(styles.sidebarSection, {
                                        // isPdpFreeShippingOnlyTestVariant Note:
                                        // we will add some marginTop to sellerInfo b/c we stripped away the sidebarBlurbs' constainer style
                                        [styles.sidebarSectionMarginTop]: isPdpFreeShippingOnlyTestVariant,
                                    })}
                                >
                                    {/* Seller Stats */}
                                    <PdpRespSidebarSellerInfo
                                        seller={item.seller}
                                        viewer={viewer}
                                        relay={relay}
                                        user={user}
                                    />

                                    {/* Questions about this piece? / Contact Dealer */}
                                    <PdpRespSidebarContact
                                        displayInfo={displayInfo}
                                        item={item}
                                        user={user}
                                        viewer={viewer}
                                        itemId={itemId}
                                        userId={userId}
                                    />
                                </div>
                            </div>
                        )}
                        <PdpRespQrCode className={styles.printShow} itemId={itemId} />
                    </div>
                </div>
            </div>

            <div className={`rowFlex ${styles.details}`}>
                <div className="colXs12 colXl9">
                    {/* About */}
                    <PdpSharedDescriptionAbout item={item} />
                    {/* Additional Options */}
                    <PdpSharedDescriptionAdditionalOptions user={user} item={item} />
                    {/* Details */}
                    <PdpRespDetails currency={currency} item={item} selectedSkuId={selectedSkuId} />
                    {/* Buyer Protection */}
                    <div className={styles.printHide}>
                        <PdpSharedBuyerProtectionBox isTrade={isTrade} withImage user={user} />
                    </div>
                    {/* Shipping and Returns */}
                    <PdpRespShippingReturns
                        isClient={isClient}
                        currency={currency}
                        relayVariables={{
                            userId,
                            itemId,
                        }}
                        viewer={viewer}
                        user={user}
                        item={item}
                        shipmentQuote={shipmentQuote}
                        shipment={shipment}
                        skuId={selectedSkuId}
                        isPdpFreeShippingFullTestVariant={isPdpFreeShippingFullTestVariant}
                    />
                    {/* Creator Content */}
                    {viewer.isAboutTheMakerEnabled && (
                        <div className={styles.printHide}>
                            <PdpSharedDescriptionAboutCreator item={item} />
                        </div>
                    )}
                    {/* Maker Content */}
                    {viewer.isAboutTheMakerEnabled && (
                        <div className={styles.printHide}>
                            <PdpSharedDescriptionAboutMaker item={item} />
                        </div>
                    )}
                </div>
            </div>

            {/* Contact Dealer Details */}
            <div className={styles.printHide}>
                <PdpRespDealerDetails user={user} item={item} viewer={viewer} currency={currency} />
            </div>

            {/* More From Seller */}
            <div className={styles.printHide}>
                <PdpRespSimilarItemsGridSeller
                    relayVariables={{
                        userId,
                        isClient,
                    }}
                    item={item}
                    sellerItems={sellerItems}
                    viewer={viewer}
                    currency={currency}
                    user={user}
                />
            </div>
            {/* You May Also Like */}
            <div className={styles.printHide}>
                <PdpRespSimilarItemsFooter
                    currency={currency}
                    viewer={viewer}
                    user={user}
                    item={item}
                    similarGridItems={similarGridItems}
                    relayVariables={relayVariables}
                />
            </div>
            {/* Recently Viewed Items */}
            <div className={`${styles.printHide} ${styles.recentlyViewed}`}>
                <SharedRecentlyViewedItems
                    itemId={item.serviceId}
                    isClient={isClient}
                    user={user}
                    onViewMoreCtaClick={trackPdpViewMoreCtaClick}
                />
            </div>
            {/* Photos - todo (INTL-70: PDP follow on) */}

            {/* More Ways To Browse */}
            <div className={styles.printHide}>
                <PdpRespSeoLinks item={item} viewer={viewer} />
            </div>
            {isClient && !viewer.disablePdpExitModal && !userId && (
                <PdpRespExitModalLazy item={item} />
            )}
            <SharedNotificationsWrapper type={SHARED_NOTIFICATION_KEYS.MULTI_PDP_VISITS}>
                {({ isEnabled }) => (
                    <PdpSharedNotificationMultiplePdpVisitsModalLoader
                        isEnabled={viewer.isFavoritesEnabled && isEnabled && !isPdpRespPreviewPage}
                        itemId={itemId}
                        environment={relay.environment}
                    />
                )}
            </SharedNotificationsWrapper>
            <SharedNotificationsWrapper type={SHARED_NOTIFICATION_KEYS.PDP_SOURCING_MODAL}>
                {({ isEnabled }) => (
                    <PdpSharedSourcingModalLoaderWrapper
                        isOpen={isEnabled}
                        itemId={itemId}
                        environment={relay.environment}
                        showInitialPrompt
                    />
                )}
            </SharedNotificationsWrapper>

            {/* Recent History */}
            {!isPdpRespPreviewPage && <PdpSharedRecentHistoryTracker item={item} />}

            {/* Buyer Assurance Box */}
            {!isTrade && (
                <div className={styles.printHide}>
                    <PdpRespBuyerAssuranceBox user={user} />
                </div>
            )}
        </div>
    );
}

PdpRespContainerComponent.propTypes = {
    currency: PropTypes.string,
    relayVariables: PropTypes.shape({
        userId: PropTypes.string,
        itemId: PropTypes.string.isRequired,
        isClient: PropTypes.bool.isRequired,
        isMultiSku: PropTypes.bool.isRequired,
        isTrade: PropTypes.bool,
        fetchUser: PropTypes.bool.isRequired,
        relationshipUserIds: PropTypes.array.isRequired,
        followSearchPages: PropTypes.array,
        fetchFollowSearch: PropTypes.bool.isRequired,
        skuId: PropTypes.string,
    }).isRequired,
    onSkuChange: PropTypes.func.isRequired,
    relay: PropTypes.object.isRequired,

    // relay response data
    viewer: PropTypes.object.isRequired,
    user: PropTypes.object,
    item: PropTypes.object.isRequired,
    displayInfo: PropTypes.object,
    sellerItems: PropTypes.object,
    similarLandingItems: PropTypes.object,
    similarGridItems: PropTypes.object,
    vipUserRelationship: PropTypes.object,
    shipmentQuote: PropTypes.object,

    // from redux
    printWithPrice: PropTypes.bool.isRequired,
    openTradeAskSellerTooltip: PropTypes.func,
};

function mapStateToProps({ pdpPrint, pdpPreviewPage }) {
    return {
        printWithPrice: pdpPrint.printWithPrice,
        isPdpRespPreviewPage: pdpPreviewPage.isPdpRespPreviewPage,
    };
}

export const PdpRespContainer = createFragmentContainer(
    connect(mapStateToProps)(PdpRespContainerComponent),
    {
        viewer: graphql`
            fragment PdpRespContainer_viewer on Viewer {
                ...PdpRespSidebarBlurbs_viewer
                ...PdpRespShippingReturns_viewer
                ...PdpRespIconBubblesWrapper_viewer
                ...PdpRespSimilarItemsFooter_viewer
                ...PdpRespSimilarItemsGridSeller_viewer
                ...PdpRespHeroCarousel_viewer @include(if: $fetchPdp)
                ...PdpRespSeoLinks_viewer
                ...PdpRespDealerDetails_viewer
                ...PdpRespSidebarContact_viewer
                ...PdpRespSidebarSellerInfo_viewer
                ...SuspectedTradeUserLoader_viewer
                ...PdpSharedShippingBadge_viewer
                ...PdpSharedShippingDetails_viewer
                ... @include(if: $fetchPdp) {
                    isAboutTheMakerEnabled: isEnabledByLocale(featureName: "ABOUT_THE_MAKER")
                    isFavoritesEnabled: isEnabledByLocale(featureName: "FAVORITES")
                    disablePdpExitModal: isEnabled(key: "disablePdpExitModal")
                    disableConsumerSourcingModal: isEnabled(key: "disableConsumerSourcingModal")
                }
            }
        `,
        user: graphql`
            fragment PdpRespContainer_user on User {
                ...PdpRespSimilarItemsGridSeller_user
                ...PdpRespSimilarItemsFooter_user
                ...PdpRespSidebarButtons_user
                ...PdpRespSidebarBlurbs_user
                ...PdpRespShippingReturns_user
                ...PdpRespBuyerAssuranceBox_user
                ...PdpRespSidebarContact_user
                ...PdpRespHeroCarousel_user
                ...PdpRespIconBubblesWrapper_user
                ...PdpRespDealerDetails_user
                ...PdpRespSidebarSellerInfo_user
                ...PdpSharedPromoCode_user
                ...PdpRespSwatchSelector_user @include(if: $isMultiSku)
                ...SharedRecentlyViewedItems_user
                ...SuspectedTradeUserLoader_user
                ...PdpSharedDescriptionAdditionalOptions_user
                ...PdpSharedShippingDetails_user
                ...PdpSharedBuyerProtectionBox_user
                ...PdpRespSimilarItemsLanding_user
            }
        `,
        item: graphql`
            fragment PdpRespContainer_item on Item {
                serviceId
                firstPhotoWebPath(size: small)
                title
                defaultSkuId
                itemType
                ...PdpRespExitModal_item
                ...PdpRespSimilarItemsLanding_item
                ...PdpRespBreadcrumbs_item
                ...PdpRespHeroCarouselPrint_item
                ...PdpRespIconBubblesWrapper_item
                ...PdpRespTitle_item
                ...PdpRespSidebarButtons_item
                ...PdpRespSidebarBlurbs_item
                ...PdpSharedDescriptionAbout_item
                ...PdpSharedDescriptionAdditionalOptions_item
                ...PdpRespShippingReturns_item
                ...PdpRespSidebarContact_item
                ...PdpRespSimilarItemsGridSeller_item
                ...PdpRespSimilarItemsFooter_item
                ...PdpSharedQuantitySelect_item
                ...PdpSharedRecentHistoryTracker_item
                ...PriceDisplay_item @arguments(hasUserId: $fetchUser, userId: $userId)
                ...PdpRespSwatchSelector_item @include(if: $isMultiSku)
                ...SuspectedTradeUserLoader_item
                ...PdpSharedShippingBadge_item
                ...PdpSharedShippingDetails_item
                ...PdpSharedTradePointsEarnedMessage_item
                ...PdpRespConsumerSourcingModalLoader_item
                ... @include(if: $fetchPdp) {
                    seller {
                        ...PdpRespSidebarSellerInfo_seller
                    }
                    ...PdpRespDealerDetails_item
                    ...PdpRespHeroCarousel_item
                    ...PdpRespDetails_item
                    ...PdpSharedDescriptionAboutCreator_item
                    ...PdpSharedDescriptionAboutMaker_item
                    ...PdpRespSeoLinks_item
                }
                skus {
                    serviceId
                    skuLeadTime: leadTime(pageType: PDP)
                    ...PriceDisplay_sku
                        @include(if: $isMultiSku)
                        @arguments(hasUserId: $fetchUser, hasSkuId: true, userId: $userId)
                }
            }
        `,
        displayInfo: graphql`
            fragment PdpRespContainer_displayInfo on ItemDisplayInfo {
                ...PdpRespSidebarButtons_displayInfo
                ...PdpRespSidebarContact_displayInfo
                ...PdpSharedPromoCode_displayInfo
                ...PdpRespSidebarBlurbs_displayInfo
                ...PriceDisplay_displayInfo
                ...PdpSharedPromoCode_displayInfo
                pricing @include(if: $isTrade) {
                    ...PdpSharedTradePointsEarnedMessage_priceInfoDisplay
                }
            }
        `,
        sellerItems: graphql`
            fragment PdpRespContainer_sellerItems on moreLikeThisConnection {
                ...PdpRespSimilarItemsGridSeller_sellerItems
            }
        `,
        similarGridItems: graphql`
            fragment PdpRespContainer_similarGridItems on moreLikeThisConnection {
                ...PdpRespSimilarItemsFooter_similarGridItems
            }
        `,
        similarLandingItems: graphql`
            fragment PdpRespContainer_similarLandingItems on moreLikeThisConnection {
                ...PdpRespSimilarItemsLanding_similarItems
            }
        `,
        vipUserRelationship: graphql`
            fragment PdpRespContainer_vipUserRelationship on UserRelationship {
                ...PdpRespSidebarBlurbs_vipUserRelationship
                ...PdpRespSimilarItemsLanding_vipUserRelationship
            }
        `,
        shipmentQuote: graphql`
            fragment PdpRespContainer_shipmentQuote on ShipmentQuote {
                ...PdpRespSidebarBlurbs_shipmentQuote
                ...PdpRespShippingReturns_shipmentQuote
                ...PdpSharedShippingDetails_shipmentQuote
            }
        `,
        shipment: graphql`
            fragment PdpRespContainer_shipment on Shipment {
                ...PdpRespSidebarBlurbs_shipment
                ...PdpRespShippingReturns_shipment
            }
        `,
        transactions: graphql`
            fragment PdpRespContainer_transactions on TransactionConnection {
                ...PriceDisplay_transactions @include(if: $isMultiSku) @arguments(hasSkuId: true)
            }
        `,
    }
);
